import { createBrowserRouter, Navigate } from "react-router-dom";
import { hasTokens } from "@crm/utils";

// Layouts
import { AppLayout } from "./components/layout/AppLayout";
import { AuthLayout } from "./components/layout/AuthLayout";

// Pages
import { LoginPage } from "./features/auth/pages/LoginPage";
import { TicketsPage } from "./features/tickets/pages/TicketsPage";
import { TicketDetailPage } from "./features/tickets/pages/TicketDetailPage";
import { NewTicketPage } from "./features/tickets/pages/NewTicketPage";

/** Protected route wrapper */
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (!hasTokens()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

/** Public route wrapper (redirect if authenticated) */
function PublicRoute({ children }: { children: React.ReactNode }) {
  if (hasTokens()) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}

export const router = createBrowserRouter([
  // Auth routes
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/login",
        element: (
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        ),
      },
    ],
  },
  // App routes (protected)
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <TicketsPage />,
      },
      {
        path: "/tickets/new",
        element: <NewTicketPage />,
      },
      {
        path: "/tickets/:id",
        element: <TicketDetailPage />,
      },
    ],
  },
  // Fallback
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);
